import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import { modalReducer } from "./slices/modal-slice.ts";
import { snackbarReducer } from "./slices/snackbar-slice.ts";
import { tableReducer } from "./slices/table-slice.ts";
import { chartConfigReducer } from "./slices/chart-config-slice.ts";
import { chartDrawerReducer } from "./slices/chart-drawer-slice.ts";
import { donutChartConfigReducer } from "./slices/donut-chart-config-slice.ts";
import { lineChartConfigReducer } from "./slices/line-chart-config-slice.ts";
import { tableConfigReducer } from "./slices/table-config-slice.ts";
import { crosstabConfigReducer } from "./slices/crosstab-config-slice.ts";
import { baseApi } from "./api/base-api";

export const store = configureStore({
  reducer: {
    modal: modalReducer,
    snackbar: snackbarReducer,
    table: tableReducer,
    chartConfig: chartConfigReducer,
    chartDrawer: chartDrawerReducer,
    donutChartConfig: donutChartConfigReducer,
    lineChartConfig: lineChartConfigReducer,
    tableConfig: tableConfigReducer,
    crosstabConfig: crosstabConfigReducer,
    // Add RTK Query base API reducer (handles all service APIs)
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      // Add RTK Query base API middleware
      .concat(baseApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
